export default "__VITE_PUBLIC_ASSET__66974da4__"